export enum ReceiptType {
  INVOICE = 'INVOICE',
  FULL_RECEIPT = 'FULL_RECEIPT',
  SIMPLE_RECEIPT = 'SIMPLE_RECEIPT',
  INVOICE_RECEIPT = 'INVOICE_RECEIPT',
  NONE = 'NONE',
}
